import {
  ChipField,
  Loading,
  ReferenceManyField,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
  Title,
  useGetOne,
} from 'react-admin';
import { Card, CardContent } from '@mui/material';

import type { UserRecord } from '@src/users';
import { getCurrentPartner } from '@src/providers/dataProvider/shared/partner';

interface ProfileRecord extends UserRecord {
  partnerName: string;
  partnerCode: string;
}

const getPartnerInfo = (): { partnerName: string, partnerCode: string } => {
  try {
    const currentPartner = getCurrentPartner();
    if (currentPartner) {
      return {
        partnerCode: currentPartner.code || '',
        partnerName: currentPartner.name || '—',
      };
    }

    return { partnerName: '—', partnerCode: '' };
  } catch {
   return { partnerName: '—', partnerCode: '' };
  }
};

export const Profile = () => {
  const uuid = sessionStorage.getItem('uuid') || '';
  const { data: user, isLoading: userLoading } = useGetOne<UserRecord>(
    'users',
    { id: uuid },
    { enabled: !!uuid }
  );

  const partnerInfo = getPartnerInfo();

  if (userLoading) {
    return <Loading loadingPrimary="" loadingSecondary="" />;
  }

  const profile: ProfileRecord = {
    id: user?.id || uuid,
    firstName: user?.firstName || '—',
    lastName: user?.lastName || '—',
    email: user?.email || '—',
    ...partnerInfo,
  };

  return (
    <>
      <Title title="Profile" />
      <Card sx={{ maxWidth: 600, mt: 2 }}>
        <CardContent>
          <SimpleShowLayout record={profile}>
            <TextField source="firstName" label="First Name" />
            <TextField source="lastName" label="Last Name" />
            <TextField source="email" label="Email" />
            <TextField source="partnerName" label="Selected Partner" />
            <ReferenceManyField
              label="Roles"
              reference="userRoles"
              target="partnerCode"
              source="partnerCode"
            >
              <SingleFieldList linkType={false}>
                <ChipField source="name" />
              </SingleFieldList>
            </ReferenceManyField>
          </SimpleShowLayout>
        </CardContent>
      </Card>
    </>
  );
};

export default Profile;
